// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1iEVk","list":"BalanceDue_list__2PzlY","listRow":"BalanceDue_listRow__sKw9s","total":"BalanceDue_total__212Ps"};